webpackJsonp([6],{

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__ = __webpack_require__(394);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_137ebac4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__ = __webpack_require__(455);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_137ebac4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_product_Index__ = __webpack_require__(446);

//
//
//


// import ComboPackage from '@/views/ComboPackage'
// import Sandwiches from '@/views/Sandwiches'
// import Lunchboxes from '@/views/Lunchboxes'
// import Drinks from '@/views/Drinks'
// import Cookies from '@/views/Cookies'


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductList',
  data: function data() {
    return {
      productComponent: null
    };
  },

  components: {
    ProductIndex: __WEBPACK_IMPORTED_MODULE_2__components_product_Index__["a" /* default */]
  },
  created: function created() {
    this.productComponent = __WEBPACK_IMPORTED_MODULE_2__components_product_Index__["a" /* default */];
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('category', ['categoryList']), {
    selectedCategory: function selectedCategory() {
      var _this = this;

      if (this.categoryList === null || this.categoryList.length < 1) {
        this.$store.dispatch('category/getCategory').then(function (catlist) {
          var tmpCategory = catlist.filter(function (a) {
            return a.UrlAliase === _this.$route.path;
          });
          if (tmpCategory !== null && tmpCategory.length > 0) {
            return tmpCategory[0];
          }
          return null;
        });
      } else {
        var tmpCategory = this.categoryList.filter(function (a) {
          return a.UrlAliase === _this.$route.path;
        });
        if (tmpCategory !== null && tmpCategory.length > 0) {
          return tmpCategory[0];
        }
        return null;
      }
    }
  })
});

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  asyncData: function asyncData(_ref) {
    var store = _ref.store,
        route = _ref.route;

    var asyncStatus = store.dispatch('product/getProductList', route);
    return asyncStatus;
  },

  name: 'dynamic-product-list',
  props: ['category'],
  data: function data() {
    return {
      component: null
    };
  },

  // created () {
  //   this.$store.dispatch('product/getProductList', this.category)
  // },
  created: function created() {
    if (!this.category) {
      // this.component = () => import('../../views/Dashboard.vue')
    } else {
      if (this.category.Template === 'Standard') {
        this.component = function () {
          return __webpack_require__.e/* import() */(18/* duplicate */).then(__webpack_require__.bind(null, 396));
        };
      } else if (this.category.Template === 'AlaCarte') {
        this.component = function () {
          return __webpack_require__.e/* import() */(20/* duplicate */).then(__webpack_require__.bind(null, 399));
        };
      } else if (this.category.Template === 'Combo') {
        this.component = function () {
          return __webpack_require__.e/* import() */(19/* duplicate */).then(__webpack_require__.bind(null, 401));
        };
      }
    }
  },

  watch: {
    category: function category() {
      if (!this.category) {
        this.component = function () {
          return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 82));
        };
      } else {
        if (this.category.Template === 'Standard') {
          this.component = function () {
            return __webpack_require__.e/* import() */(18/* duplicate */).then(__webpack_require__.bind(null, 396));
          };
        } else if (this.category.Template === 'AlaCarte') {
          this.component = function () {
            return __webpack_require__.e/* import() */(20/* duplicate */).then(__webpack_require__.bind(null, 399));
          };
        } else if (this.category.Template === 'Combo') {
          this.component = function () {
            return __webpack_require__.e/* import() */(19/* duplicate */).then(__webpack_require__.bind(null, 401));
          };
        }
      }
    }
  }
});

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(395);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b19bd14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(454);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b19bd14_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui fluid container fc-product-container"},[(_vm.category != null && _vm.category != undefined)?_c('div',{staticClass:"fc-banner",style:({backgroundColor: _vm.category.BgColor})},[_c('div',{staticClass:"ui container"},[_c('div',[_c('div',{staticClass:"fc-crumbs"},[_c('router-link',{attrs:{"to":("" + (this.RouterConfig.Home))}},[_vm._v("Home")]),_vm._v("\n          >\n          "),_c('span',[_vm._v(_vm._s(_vm.category.Name))])],1),_vm._v(" "),_c('div',{staticClass:"fc-title"},[_vm._v("\n          "+_vm._s(_vm.category.Name)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"fc-desc"},[_vm._v("\n          "+_vm._s(_vm.category.Descriptions)+"\n        ")])]),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":_vm.category.PhotoKey}})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ui container"},[(_vm.component)?_c(_vm.component,{tag:"component",attrs:{"category":_vm.category}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.productComponent,{tag:"component",attrs:{"category":_vm.selectedCategory}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.js?v=1698631571653